var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep3(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A82939;}\n\t.st1{fill:none;stroke:#75232E;stroke-width:5;}\n\t.st2{fill:#A21B2C;}\n\t.st3{fill:none;stroke:#75232E;stroke-width:4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,58.7c6.8,0,12.3-3.9,12.3-10.6c0-4.9-3.4-8.2-7.6-9.2v-0.2c3.9-1.5,6.4-4.4,6.4-8.7 c0-6.1-4.7-9.5-11.2-9.5c-4.2,0-7.7,1.8-10.5,4.4l3,3.6c2.1-2.1,4.5-3.4,7.3-3.5c3.5,0.1,5.7,2.1,5.7,5.3c0,3.7-2.4,6.4-9.7,6.4 v4.2c8.3,0,10.9,2.7,10.9,6.7c0,3.8-2.9,6.1-7,6.1c-3.8,0-6.6-1.8-8.7-4l-2.8,3.7C30.6,56.3,34.3,58.7,40.1,58.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 40,
    cy: 40,
    r: 37.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.11de2f6a.svg";
export { ForwardRef as ReactComponent };